<ng-container *ngIf="isLoggedIn$ | async as user; else loginOnly">
    <app-header (languageChanged)="onLanguageChanged($event)"></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </ng-container>
  
  <ng-template #loginOnly>
    <router-outlet></router-outlet>
  </ng-template>
  